import { render } from "./WhatsApp.vue?vue&type=template&id=c165be9e"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
script.render = render

export default script